/** Convert millicents to euros (float) */
export const millicentsToEuros = (mc: number): number => mc / 100000

/** Convert euros (user input) to millicents for storage */
export const eurosToMillicents = (euros: number): number => Math.round(euros * 100000)

/**
 * Format a millicent value as a euro string.
 * Uses more decimal places for very small values (sub-cent ingredient costs).
 */
export const formatCost = (mc: number | null): string => {
  if (mc === null || mc === undefined) return '—'
  const euros = millicentsToEuros(mc)
  if (euros === 0) return '€0.00'
  if (Math.abs(euros) < 0.001) return `€${euros.toFixed(6)}`
  if (Math.abs(euros) < 0.01) return `€${euros.toFixed(5)}`
  if (Math.abs(euros) < 1) return `€${euros.toFixed(4)}`
  return `€${euros.toFixed(2)}`
}

/** Format cost per unit with unit label */
export const formatCostPerUnit = (mc: number | null, unit: string): string => {
  if (mc === null || mc === undefined) return '—'
  return `${formatCost(mc)} / ${unit}`
}

/** Calculate and format line cost (cost per unit × quantity) */
export const formatLineCost = (mc: number | null, quantity: number): string => {
  if (mc === null || mc === undefined) return '—'
  return formatCost(mc * quantity)
}

/** Format a date string to a readable local date */
export const formatDate = (iso: string): string => {
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return iso
  }
}

/** Display label for a unit */
export const unitLabel = (unit: string): string => {
  const labels: Record<string, string> = {
    g: 'grams (g)',
    kg: 'kilograms (kg)',
    ml: 'millilitres (ml)',
    l: 'litres (l)',
    piece: 'piece',
  }
  return labels[unit] ?? unit
}
